import { createAxiosInstance } from '@applyboard/ui-utils';

// Duplicated from ab-common
export var uploadSingleFile = function uploadSingleFile(url, fieldName, file) {
  var customAxiosInstance = createAxiosInstance({
    file: true
  });
  var formData = new FormData();
  formData.append(fieldName, file);
  return customAxiosInstance.put(url, formData);
};

// Duplicated from ab-common
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export var uploadSingleFilePost = function uploadSingleFilePost(url, fieldName, file, onProgress) {
  var customAxiosInstance = createAxiosInstance({
    file: true,
    onUploadProgress: onProgress
  });
  var formData = new FormData();
  formData.append(fieldName, file);
  return customAxiosInstance.post(url, formData);
};